import { ActionsUnion, createAction } from '../../../redux/customActions';
import { Banner } from '../../models/BannerModel';

export const Actions = {
    bannerFetching: () => createAction('banner/bannerRequested'),
    bannerFailed: () => createAction('banner/bannerRequestFailed'),
    bannerRetrieved: (banner: Banner) => createAction('banner/bannerReceived', { banner }),
};

export type ActionsType = ActionsUnion<typeof Actions>;
